module.exports = __webpack_public_path__ + "img/1.7818080f.jpg";